import Icon from '../components/Icon.vue'

Icon.register({
  comments: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M416 192C416 103.6 322.9 32 208 32S0 103.6 0 192C0 226.3 14.1 257.9 38 284 24.6 314.2 2.5 338.2 2.2 338.5 0 340.8-0.6 344.2 0.7 347.2S4.8 352 8 352C44.6 352 74.9 339.7 96.7 327 128.9 342.7 167 352 208 352 322.9 352 416 280.4 416 192zM538 412C561.9 386 576 354.3 576 320 576 253.1 522.5 195.8 446.7 171.9 447.6 178.5 448 185.2 448 192 448 297.9 340.3 384 208 384 197.2 384 186.7 383.2 176.3 382.1 207.8 439.6 281.8 480 368 480 409 480 447.1 470.8 479.3 455 501.1 467.7 531.4 480 568 480 571.2 480 574.1 478.1 575.3 475.2 576.6 472.3 576 468.9 573.8 466.5 573.5 466.2 551.4 442.3 538 412z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/comments.js
// module id = wdG2
// module chunks = 144